import React from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  DialogContentText,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { EventContext } from "../../../contexts/EventContext";
import request from "../../../utilities/requests";

const StartEvent = () => {
  const { pairingEvent, setPairingEvent, userData, pairingData } =
    React.useContext(EventContext);
  const [open, setOpen] = React.useState(false);
  const [status, setStatus] = React.useState("scheduled");
  const [showNotificationOption, setShowNotificationOption] =
    React.useState(false);
  const [sendNotifications, setSendNotifications] = React.useState(false);
  const [withoutRounds, setWithoutRounds] = React.useState(0);
  const [acknowledge, setAcknowledge] = React.useState(true);

  React.useEffect(() => {
    if (pairingEvent) {
      setStatus(pairingEvent.event.status);
    }
  }, [pairingEvent]);

  React.useEffect(() => {
    if (userData?.org?.config?.userNotificationsEnabled) {
      setShowNotificationOption(true);
    }
  }, [userData]);

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    let wr = 0;
    if (pairingData) {
      pairingData.byAttendee.map((attendee) => {
        if (attendee.checkedIn && attendee.rounds.length === 0) wr++;
      });
      setWithoutRounds(wr);
      if (wr > 0) {
        setAcknowledge(false);
      } else {
        setAcknowledge(true);
      }
    }
  }, [pairingData, status]);

  const handleStart = async () => {
    const body = {
      pairingEventId: pairingEvent._id,
      sendNotifications,
    };
    let result = await request("pairingevent/startevent", "post", body);
    if (!result.success) {
    } else {
      setPairingEvent(result.pairingEvent);
    }
    setOpen(false);
  };

  const updateEventStatus = async (newStatus) => {
    const body = {
      eventId: pairingEvent.event._id,
      update: {
        status: newStatus,
      },
    };
    let result = await request("events/update", "post", body);
    if (!result.success) {
    } else {
      setStatus(newStatus);
      pairingEvent.event.status = newStatus;
      setPairingEvent({ ...pairingEvent });
    }
  };

  const handleChange = (event) => {
    let newStatus = event.target.value;
    if (newStatus === "active") {
      console.log(pairingData);
      setOpen(true);
    } else {
      updateEventStatus(newStatus);
    }
  };

  return (
    <>
      <FormControl style={{ width: 160 }} size="small">
        <InputLabel id="label">Status</InputLabel>
        <Select
          labelId="label"
          value={status}
          label="Status"
          onChange={handleChange}
        >
          <MenuItem value={"scheduled"}>Scheduled</MenuItem>
          <MenuItem value={"pending"}>Pending</MenuItem>
          <MenuItem value={"active"}>Active</MenuItem>
          <MenuItem value={"completed"}>Completed</MenuItem>
          {/* <MenuItem value={"active"}>Completed</MenuItem> */}
        </Select>
      </FormControl>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Start Event?"}</DialogTitle>
        <DialogContent>
          {withoutRounds > 0 ? (
            <>
              <DialogContentText sx={{fontWeight: 'bold', color: 'red'}}>
                There are {withoutRounds} attendees without any rounds!
              </DialogContentText>
              <DialogContentText id="alert-dialog-description">
                If you start the event, {withoutRounds} people will not have
                any dates. If you are aware of this click Acknowledge below and
                then the start button. If this doesn't seem right, have you created your matches for the event? 
              </DialogContentText>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={acknowledge}
                    onChange={() => setAcknowledge(!acknowledge)}
                  />
                }
                label="Acknowledge"
              />
            </>
          ) : (
            <DialogContentText id="alert-dialog-description">
              Are you sure you are ready to start the event?
            </DialogContentText>
          )}

          {showNotificationOption ? (
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={sendNotifications}
                    onChange={() => setSendNotifications(!sendNotifications)}
                  />
                }
                label="Send Notification"
              />
            </FormGroup>
          ) : (
            <></>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleStart} autoFocus disabled={acknowledge === false ? true : false}>
            Start It!
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default StartEvent;
